module.exports = __webpack_public_path__ + "static/banner-2-62647071d9db6f07feb1fcd9af145858.jpg";